import { type CustomFieldDefinition } from 'components/framework/models';
import Field from './Field';
import CustomFieldValue from 'components/framework/models/CustomFieldValue';
import FieldSet from '../models/FieldSet';
import { type CardLayoutModelType } from './types';

type CustomFieldableType = Extract<
  CardLayoutModelType,
  { customFieldValues: CustomFieldValue[] }
>;

export default class CustomField extends Field {
  constructor(public customFieldDefinition: CustomFieldDefinition) {
    super(null);
  }

  get id(): any {
    if (this.customFieldDefinition.id) {
      return this.customFieldDefinition.id;
    } else {
      return (
        // @ts-ignore
        this.customFieldDefinition.recordFields.attributes.id + '_' + this.key
      );
    }
  }

  get key() {
    if (this.customFieldDefinition.key) {
      return this.customFieldDefinition.key;
    } else {
      return this.constructor.name;
    }
  }

  get title() {
    return this.customFieldDefinition.name;
  }

  get type() {
    return this.customFieldDefinition.type;
  }

  get cardFieldType() {
    switch (this.type) {
      case 'LinkMany':
      case 'LinkOne':
        return aha.enums.CardFieldTypesEnum.CUSTOM_OBJECT_LINK.value;

      default:
        if (this.customFieldDefinition instanceof FieldSet) {
          return aha.enums.CardFieldTypesEnum.CUSTOM_FIELD_SET.value;
        } else {
          return aha.enums.CardFieldTypesEnum.CUSTOM_FIELD.value;
        }
    }
  }

  customFieldValueForRecord(record: CustomFieldableType) {
    return record.customFieldValues?.find(
      customFieldValue => customFieldValue.key === this.key
    );
  }

  buildScope(query) {
    return query.deepMerge({
      customFieldValues: CustomFieldValue.select(
        'key',
        'value',
        'humanValue'
      ).argument({
        ids: this.id,
      }),
    });
  }
}
